<template>
<div class="chapter">
<div class="inner_page">
<p class="h1">Contents</p>
<p class="toc"><a href="#/foreword">Foreword, by Henry Middleton Rutledge</a></p>
<p class="toc"><a href="#/introduction">Introduction, by Selden B. Hill</a></p>
<p class="toc1"><a href="#/gods">G<span class="small">OD</span>’<span class="small">S</span> C<span class="small">HILDREN</span></a></p>
<table width="100%">
<colgroup><col width="07%"/>
<col width="93%"/>
</colgroup><tbody><tr>
<td valign="top"><p class="toc1"><span href="#/chapter01" title="Link target outside of Sample">I.</span></p></td>
<td valign="top"><p class="toc1"><span href="#/chapter01" title="Link target outside of Sample">Black Henchmen</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/chapter02" title="Link target outside of Sample">II.</span></p></td>
<td valign="top"><p class="toc"><span href="#/chapter02" title="Link target outside of Sample">Plantation Lights and Shadows</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/chapter03" title="Link target outside of Sample">III.</span></p></td>
<td valign="top"><p class="toc"><span href="#/chapter03" title="Link target outside of Sample">Dusky Dilemmas</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/chapter04" title="Link target outside of Sample">IV.</span></p></td>
<td valign="top"><p class="toc"><span href="#/chapter04" title="Link target outside of Sample">Dark Valor</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/chapter05" title="Link target outside of Sample">V.</span></p></td>
<td valign="top"><p class="toc"><span href="#/chapter05" title="Link target outside of Sample">God’s Children</span></p></td>
</tr>
<tr>
<td valign="top"><p class="toc"><span href="#/chapter06" title="Link target outside of Sample">VI.</span></p></td>
<td valign="top"><p class="toc"><span href="#/chapter06" title="Link target outside of Sample">Black Woodsmen</span></p></td>
</tr>
</tbody></table>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?4661e6e6